import apiClient from '../utils/apiClient';

/**
 * Holiday API Services
 * Quản lý ngày lễ - ảnh hưởng đến salary multiplier
 */

export const holidayAPI = {
  /**
   * Lấy danh sách ngày lễ
   * @param {Object} params - Tham số truy vấn
   * @param {number} params.year - Năm (ví dụ: 2026)
   * @param {string} params.branch_id - ID chi nhánh
   * @returns {Promise<Array>} Danh sách ngày lễ
   */
  getHolidays: async (params = {}) => {
    const { year, branch_id } = params;
    return await apiClient.get({
      url: '/holidays',
      params: {
        ...(year ? { year } : {}),
        ...(branch_id ? { branch_id } : {}),
      },
    });
  },

  /**
   * Lấy thông tin chi tiết ngày lễ theo ID
   * @param {string} holidayId - ID ngày lễ
   * @returns {Promise<Object>} Thông tin chi tiết ngày lễ
   */
  getHolidayById: async (holidayId) => {
    return await apiClient.get({
      url: `/holidays/${holidayId}`,
    });
  },

  /**
   * Kiểm tra ngày có phải ngày lễ không
   * @param {Object} params - Tham số
   * @param {string} params.date - Ngày cần kiểm tra (YYYY-MM-DD)
   * @param {string} params.branch_id - ID chi nhánh (optional)
   * @returns {Promise<Object>} Kết quả kiểm tra
   */
  checkHoliday: async (params) => {
    const { date, branch_id } = params;
    return await apiClient.get({
      url: '/holidays/check',
      params: {
        date,
        ...(branch_id ? { branch_id } : {}),
      },
    });
  },

  /**
   * Lấy ngày lễ theo năm
   * @param {number} year - Năm
   * @returns {Promise<Array>} Danh sách ngày lễ trong năm
   */
  getHolidaysByYear: async (year) => {
    return await apiClient.get({
      url: `/holidays/year/${year}`,
    });
  },

  /**
   * Tạo ngày lễ mới
   * @param {Object} holidayData - Dữ liệu ngày lễ
   * @param {string} holidayData.name - Tên ngày lễ
   * @param {string} holidayData.date - Ngày (YYYY-MM-DD)
   * @param {number} holidayData.month - Tháng (1-12)
   * @param {number} holidayData.day - Ngày (1-31)
   * @param {boolean} holidayData.is_fixed - Ngày lễ cố định theo ngày hay thứ
   * @param {boolean} holidayData.is_active - Trạng thái active
   * @param {string} holidayData.branch_id - ID chi nhánh (null = tất cả)
   * @returns {Promise<Object>} Thông tin ngày lễ vừa tạo
   */
  createHoliday: async (holidayData) => {
    return await apiClient.post({
      url: '/holidays',
      data: holidayData,
    });
  },

  /**
   * Cập nhật ngày lễ
   * @param {string} holidayId - ID ngày lễ
   * @param {Object} updateData - Dữ liệu cập nhật
   * @returns {Promise<Object>} Thông tin ngày lễ sau khi cập nhật
   */
  updateHoliday: async (holidayId, updateData) => {
    return await apiClient.patch({
      url: `/holidays/${holidayId}`,
      data: updateData,
    });
  },

  /**
   * Xóa ngày lễ
   * @param {string} holidayId - ID ngày lễ
   * @returns {Promise<Object>} Kết quả xóa
   */
  deleteHoliday: async (holidayId) => {
    return await apiClient.delete({
      url: `/holidays/${holidayId}`,
    });
  },
};

